<template>
  <div class="position-relative">
    <div class="menu_wrapp">
      <div
        @click="handleDigitMenu"
        @mouseleave="isActive = false"
        class="dex_digit"
      >
        <div class="digit_item">
          <span>{{ valueSelected }}</span>
          <svg
            width="15"
            height="7"
            viewBox="0 0 19 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.2195 0L9.10975 10.9317L0 0H18.2195Z"
              fill="aliceblue"
            />
          </svg>
        </div>

        <div class="digit_lists" :class="{ menu_active: isActive }">
          <span @click="changeDigitFloat('0.0001')">0.0001</span
          ><span @click="changeDigitFloat('0.001')">0.001</span
          ><span @click="changeDigitFloat('0.01')">0.01</span
          ><span @click="changeDigitFloat('0.1')">0.1</span
          ><span @click="changeDigitFloat('1')">1</span>
        </div>
      </div>
    </div>

    <!-- Desktop -->
    <table class="table my-balances-table d-none d-lg-block">
      <thead>
        <tr>
          <th class="text-left">Simbol</th>
          <th class="text-left">Nama</th>
          <th class="text-left">Dalam Proses</th>
          <th class="text-left">Tersedia</th>
          <th class="text-left">Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in balances" :key="item.id">
          <!-- Simbol -->
          <td>
            <img
              :src="item.ccurrency_obj.ccurrency_icon_data_url"
              :alt="item.ccurrency_name"
              width="20"
              style="margin-right: 10px; border-radius: 100%"
            />
            {{ item.ccurrency_symbol }}
          </td>

          <!-- Nama -->
          <td>
            {{ item.ccurrency_obj.ccurrency_name }}
          </td>

          <!-- Dalam Proses -->
          <td>
            {{
              themain.formatBalance(
                item.saldo_lock,
                item.ccurrency_symbol,
                floatDigit
              )
            }}
          </td>

          <!-- Tersedia -->
          <td>
            {{
              themain.formatBalance(
                item.saldo_value,
                item.ccurrency_symbol,
                floatDigit
              )
            }}
          </td>

          <!-- Total -->
          <td>
            {{
              rowTotalBalance(
                item.saldo_lock,
                item.saldo_value,
                item.ccurrency_symbol
              )
            }}
          </td>
          <td>
            <button
              v-if="canStartKyc"
              class="btn btn-sm btn-outline-yellow"
              @click="openKyc"
            >
              Mulai KYC
            </button>
            <KycInProcessLabel v-else-if="isKycPending" />
            <template v-else>
              <!-- khusus IDR saja -->
              <div v-if="item.ccurrency_symbol == 'IDR'">
                <router-link
                  :to="`/settings/wallets/idr_deposit`"
                  class="btn btn-sm btn-outline-yellow mr-1"
                >
                  Deposit
                </router-link>
                <router-link
                  :to="`/settings/wallets/idr_withdraw`"
                  class="btn btn-sm btn-outline-yellow"
                >
                  Withdraw
                </router-link>
              </div>

              <!-- khusus BTC saja -->
              <div v-else-if="item.ccurrency_symbol == 'BTC'">
                <router-link
                  :to="`/settings/wallets/btc_deposit`"
                  class="btn btn-sm btn-outline-yellow mr-1"
                >
                  Deposit
                </router-link>
                <router-link
                  :to="`/settings/wallets/btc_withdraw`"
                  class="btn btn-sm btn-outline-yellow"
                >
                  Withdraw
                </router-link>
              </div>

              <!-- selainnya disini -->
              <div v-else>
                <router-link
                  :to="`/settings/wallets/${item.ccurrency_symbol}/deposit`"
                  class="btn btn-sm btn-outline-yellow mr-1"
                >
                  Deposit
                </router-link>
                <router-link
                  :to="`/settings/wallets/${item.ccurrency_symbol}/withdraw`"
                  class="btn btn-sm btn-outline-yellow"
                >
                  Withdraw
                </router-link>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile -->
    <table class="table my-balances-table-vertical d-block d-lg-none">
      <div
        v-for="item in balances"
        :key="item.id"
        class="m-3 border border-dark text-light"
      >
        <!-- Simbol -->
        <div class="id_heading px-3 py-2">
          <img
            :src="item.ccurrency_obj.ccurrency_icon_data_url"
            :alt="item.ccurrency_name"
            width="20"
            style="margin-right: 10px; border-radius: 100%"
          />
          {{ item.ccurrency_symbol }}
        </div>
        <div class="p-3">
          <!-- Nama -->
          <div class="row row-cols">
            <div class="col-5 d-flex justify-content-between">
              <span>Nama</span> <span>:</span>
            </div>
            <div class="col-7">
              {{ item.ccurrency_obj.ccurrency_name }}
            </div>
          </div>

          <!-- Dalam Proses -->
          <div class="row row-cols">
            <div class="col-5 d-flex justify-content-between">
              <span>Dalam Proses</span> <span>:</span>
            </div>
            <div class="col-7">
              {{
                themain.formatBalance(
                  item.saldo_lock,
                  item.ccurrency_symbol,
                  floatDigit
                )
              }}
            </div>
          </div>

          <!-- Tersedia -->
          <div class="row row-cols">
            <div class="col-5 d-flex justify-content-between">
              <span>Tersedia</span> <span>:</span>
            </div>
            <div class="col-7">
              {{
                themain.formatBalance(
                  item.saldo_value,
                  item.ccurrency_symbol,
                  floatDigit
                )
              }}
            </div>
          </div>

          <!-- Total -->
          <div class="row row-cols">
            <div class="col-5 d-flex justify-content-between">
              <span>Total</span> <span>:</span>
            </div>
            <div class="col-7">
              {{
                rowTotalBalance(
                  item.saldo_lock,
                  item.saldo_value,
                  item.ccurrency_symbol
                )
              }}
            </div>
          </div>
        </div>
        <div>
          <button
            v-if="canStartKyc"
            class="btn btn-sm btn-outline-yellow w-100"
            @click="openKyc"
          >
            Mulai KYC
          </button>
          <KycInProcessLabel v-else-if="isKycPending" block />
          <template v-else>
            <!-- khusus IDR saja -->
            <div v-if="item.ccurrency_symbol == 'IDR'">
              <router-link
                :to="`/settings/wallets/idr_deposit`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Deposit
              </router-link>
              <router-link
                :to="`/settings/wallets/idr_withdraw`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Withdraw
              </router-link>
            </div>

            <!-- khusus BTC saja -->
            <div v-else-if="item.ccurrency_symbol == 'BTC'">
              <router-link
                :to="`/settings/wallets/btc_deposit`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Deposit
              </router-link>
              <router-link
                :to="`/settings/wallets/btc_withdraw`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Withdraw
              </router-link>
            </div>

            <!-- selainnya disini -->
            <div v-else>
              <router-link
                :to="`/settings/wallets/${item.ccurrency_symbol}/deposit`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Deposit
              </router-link>
              <router-link
                :to="`/settings/wallets/${item.ccurrency_symbol}/withdraw`"
                class="btn btn-sm btn-outline-yellow w-50"
              >
                Withdraw
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </table>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import { mapState } from "vuex";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";
import KycInProcessLabel from "./KycInProcessLabel.vue";

export default {
  components: { KycInProcessLabel },

  props: {
    resetDigitOnMount: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      pageObj: {
        page: 1,
        rows: 50,
        sort: "id",
        order: "asc",
        filter_rules: [],
      },
      balances: [],
      user: {},

      isActive: false,
    };
  },

  sockets: {
    connect: function () {
      console.log("socket connected -bal");
    },

    /**
     * ubal hanya berisi saldo_value (tanpa saldo_lock).
     * Lock dihitung di BalanceLockJob setelah emit → harus refetch API
     * agar kolom "Dalam Proses" / Total ikut terbarui tanpa hard refresh.
     */
    ubal: function (data) {
      var self = this;
      var obj;
      try {
        obj = typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        return;
      }
      if (!Array.isArray(obj)) {
        obj = [obj];
      }

      var mine = false;
      obj.forEach(function (el) {
        if (!el || parseInt(self.usid, 10) !== parseInt(el.u, 10)) {
          return;
        }
        mine = true;
        // Patch cepat nilai tersedia (sebelum refetch selesai)
        self.applyUbalSnapshot(el);
      });

      if (mine) {
        self.scheduleBalanceRefresh();
      }
    },
  },

  computed: {
    ...mapState(["valueSelected", "floatDigit"]),
    isKycApproved() {
      return this.user.orang_kyc_status === "approve";
    },
    isKycPending() {
      return this.user.orang_kyc_status === "pending";
    },
    canStartKyc() {
      const status = this.user && this.user.orang_kyc_status;
      return status !== "approve" && status !== "pending";
    },
  },

  async beforeMount() {
    if (this.resetDigitOnMount) {
      await this.$store.dispatch("changeDigitFloat", "0.0001");
    }
  },

  async mounted() {
    var self = this;
    await Promise.all([self.getBalances(), self.getMyData()]);
  },

  beforeUnmount() {
    if (this._balanceRefreshTimer) {
      clearTimeout(this._balanceRefreshTimer);
      this._balanceRefreshTimer = null;
    }
  },

  methods: {
    async getMyData() {
      this.user = await thestore.getMyProfileData(this.token);
    },

    openKyc() {
      if (this.isKycPending) return;
      this.emitter.emit("show-kyc-modal");
    },

    applyUbalSnapshot(balObjSocket) {
      var self = this;
      var next = self.balances.map(function (elbal) {
        var patched = Object.assign({}, elbal);
        Object.keys(balObjSocket).forEach(function (balSocketKey) {
          if (balSocketKey === "u") {
            return;
          }
          if (
            String(elbal.ccurrency_symbol).toUpperCase() ===
            String(balSocketKey).toUpperCase()
          ) {
            patched.saldo_value = balObjSocket[balSocketKey];
          }
        });
        return patched;
      });
      self.balances = next;
    },

    scheduleBalanceRefresh() {
      var self = this;
      // Immediate: saldo_value sudah di DB
      self.getBalances();
      // Delayed: tunggu BalanceLockJob selesai update saldo_lock
      if (self._balanceRefreshTimer) {
        clearTimeout(self._balanceRefreshTimer);
      }
      self._balanceRefreshTimer = setTimeout(function () {
        self.getBalances();
        self._balanceRefreshTimer = null;
      }, 1200);
    },

    async getBalances() {
      var self = this;

      var balanceRes = await thestore.getBalances(
        self.token,
        self.pageObj.page,
        self.pageObj.rows,
        self.pageObj.sort,
        self.pageObj.order,
        self.pageObj.filter_rules
      );

      var visible = (balanceRes.datas || []).filter(
        (item) =>
          item.ccurrency_obj && item.ccurrency_obj.ccurrency_show == "yes"
      );

      // DB bisa punya double saldo per simbol; tampilkan 1 baris saja
      // dan pertahankan entri dengan total saldo terbesar.
      var bySymbol = {};
      var order = [];
      visible.forEach(function (item) {
        var symbol = String(item.ccurrency_symbol || "").toUpperCase();
        if (!symbol) return;

        var total =
          (parseFloat(item.saldo_lock) || 0) +
          (parseFloat(item.saldo_value) || 0);
        var existing = bySymbol[symbol];
        if (!existing) {
          bySymbol[symbol] = item;
          order.push(symbol);
          return;
        }

        var existingTotal =
          (parseFloat(existing.saldo_lock) || 0) +
          (parseFloat(existing.saldo_value) || 0);
        if (total > existingTotal) {
          bySymbol[symbol] = item;
        }
      });

      self.balances = order.map(function (symbol) {
        return bySymbol[symbol];
      });
    },

    rowTotalBalance(saldo_lock, saldo_value, currency) {
      var self = this;
      var total = parseFloat(saldo_lock) + parseFloat(saldo_value);
      return themain.formatBalance(total, currency, self.floatDigit);
    },

    handleDigitMenu() {
      var self = this;

      self.isActive = !self.isActive;
    },

    changeDigitFloat(val) {
      var self = this;

      this.$store.dispatch("changeDigitFloat", val);

      self.getBalances();
    },
  },
};
</script>

<style scoped>
.my-balances-table thead tr,
.my-balances-table tbody tr {
  display: table;
  table-layout: fixed;
  width: 100%;
}

.my-balances-table td {
  padding: 5px;
  padding-left: 15px;
}

.my-balances-table tbody tr td,
.my-balances-table-vertical {
  word-wrap: break-word;
}

.menu_wrapp {
  position: absolute;
  top: -32px;
  right: 0%;
  padding-right: 10px;
}

.dex_digit {
  position: relative;
  cursor: pointer;
}

.digit_item {
  width: 70px;
  border-radius: 3px;
  border: 1px solid #343a40;
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 22px;
}

.digit_item span {
  color: aliceblue;
}

.digit_lists {
  position: absolute;
  /* margin-right: 10px; */
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  background-color: #262c34;
  border: 1px solid #262c34;
  border-radius: 3px;
  width: 70px;
  z-index: 999;

  transition-duration: 0.5s;
}

.menu_active {
  display: flex;
}

.digit_lists span {
  color: aliceblue;
  width: 100%;
  display: flex;
  justify-content: center;
}

.digit_lists span:hover {
  background-color: #343a40;
}

.btn-outline-yellow {
  border-color: #fedba1;
  color: #fedba1;
}

.btn-outline-yellow:hover {
  border: 1px solid #00ac72 !important;
  color: #00ac72 !important;
}

.my-balances-table-vertical {
  padding-bottom: 77px;
}

.my-balances-table-vertical .id_heading {
  font-weight: bold;
  background-color: #1c2030;
}

@media only screen and (max-width: 767px) {
  .small_font {
    font-size: 0.65rem;
  }

  .menu_wrapp {
    top: -48px;
  }
}
</style>
